import $ from 'jquery'
import { closeModal } from '@/function/function.js';
import ExcelModal from '@/views/parametres/import-excel-modal'
import store_analyse from '@/store/mods/analyses/analyse'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';

export default {
    name: 'liste-analyse',
    components: {
        ExcelModal
    },
    props: [],
    data () {
        return {
            user_role: '',           //  Role d'un utilisateur
            // fields: [ {key:'nom',label: 'Noms'}, {key:'prix',label: 'Prix'},'actions'],
            fields: [ 
                {key:'nom', label: 'Analyse'}, {key:'technique_utilisee', label: 'Technique utilisée'}, 
                {key:'prix', label: 'Prix'}, 'actions'
            ],
            print_fields: [
                {key:'nom', label: 'Analyse'}, {key:'technique_utilisee', label: 'Technique utilisée'}, 
                {key:'prix', label: 'Prix'}
            ],
            // fields: [{ key: 'index', label: 'N°' }, 'abreviation', 'nom','categorie',{key:'prix',label:' Prix'},'actions'],
            laboFields: [{ key: 'index', label: 'N°' }, 'abreviation', 'nom', 'actions'],

            filter: "",
            search_filter: [],
           
            tableIsBusy:  true,
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            selectedAnalyse: null,

            is_printing: false,
            filename: '',

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            json_fields: {
                'Catégorie': 'categorie',
                'Libellé': 'libelle',
                'Abreviation': 'abreviation',
                'Prix': 'prix',
                'Technique utilisée': 'technique_utilisee'
            },

            json_data: [],
            export_filename: 'Liste_Analyses.xls',
            can_print: false,
            liste_distinct_analyses: [],

            analyses_by_category: [],
            anl_loading: true,
            anl_empty: false,

            category_filter: [],
            selected_category: {
                id: 0,
                categorie: 'Toutes les catégories'
            },
            vm_state: open_menu_state,
            
            anl_loading_percentage: 0,
            can_view_percentage: false,
            anl_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
            cat_analyse_len: 0
        }
    },

    watch: {
        selected_category() {
            this.showByCategory()
        }
    },

    computed: {
        analyses() {
            return this.$store.getters['analyses']
        },

        rows() {
            return this.analyses.length;
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    beforeDestroy() {
        if (this.anl_refresh_timeout_id) {
            clearTimeout(this.anl_refresh_timeout_id)
            this.anl_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted () {
        const ts = this;
        $(document).bind("click", function (e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }
        this.getAnalyseByCategorie()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_des_analyses_'+tmpstamp

        // this.selectDistinctAnalyse()
    },
    methods: {
        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListAnalyse'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.anl_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.anl_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.anl_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeAnalyse() {
            this.anl_loading = true
            this.can_view_percentage = true
            if (this.anl_refresh_timeout_id) {
                clearTimeout(this.anl_refresh_timeout_id)
                this.anl_refresh_timeout_id = null
            }

            if (this.cat_analyse_len > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.getAnalyseByCategorie()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.getAnalyseByCategorie()
            this.anl_refresh_timeout_id = setTimeout(() => {
                this.refreshListeAnalyse()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeAnalyse()
        },

        getAnalyseByCategorie() {
            this.anl_loading = true
            store_analyse.getListeAnalyseByCategory().then((cat_analyses) => {
                this.cat_analyse_len = cat_analyses.length
                if (cat_analyses.length == 0) {
                    this.analyses_by_category = []
                    this.anl_empty = true
                } else {
                    this.analyses_by_category = cat_analyses
                    this.anl_empty = false

                    const select_all = {
                        id: 0,
                        categorie: 'Toutes les catégories'
                    }
                    this.category_filter.push(select_all)

                    for (let i = 0; i < cat_analyses.length; i++) {
                        this.search_filter[i] = "" 

                        const tmp_category = {
                            id: cat_analyses[i].id,
                            categorie: cat_analyses[i].categorie
                        }
                        this.category_filter.push(tmp_category)
                    }

                    this.json_data = []
                    cat_analyses.forEach(cat => {
                        cat.analyses.forEach(anl => {
                            this.json_data.push({
                                'categorie': cat.categorie, 
                                'libelle' : anl.analyse,
                                'abreviation': anl.abreviation,
                                'prix' : (anl.prix > 0)?anl.prix:'',
                                'technique_utilisee': (anl.technique_utilisee != null)?anl.technique_utilisee:''
                            })
                        });
                    });
                }

                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.anl_loading = false
                    }
                } else {
                    this.anl_loading = false
                }
            })
        },

        deleteAnalyse: function (id){
            this.$store.dispatch('deleteAnalyse',id).then(() => {
                this.$refs.closeDeleteAnalyseBtn.click();
                this.deletionAnalyseSuccess()
                this.getAnalyseByCategorie()
            })
        },

        modalDeleteAnalyse: function(analyse){
            this.selectedAnalyse = analyse
        },

        deletionAnalyseSuccess: function(){
            this.$toasted.show('L\'analyse a été supprimée avec succès',{
                duration: 5000,
                action:[
                    {
                        text:'X',
                        onClick:(e,toastObject)=>{
                            toastObject.goAway(0);
                        }
                    }
                ],
                theme:'toasted-primary',
                type:'success'
            })
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Analyses_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        printListeAnalyse() {
            this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 500);
        },

        selectDistinctAnalyse() {
            this.json_data = []
            store_analyse.getDistinctAnalyse().then((response) => {
                this.liste_distinct_analyses = response

                if (this.liste_distinct_analyses.length > 0) {
                    this.liste_distinct_analyses.forEach(analyse => {
                        this.json_data.push({
                            'nom_analyse' : analyse.nom_analyse,
                            'categorie': analyse.categorie
                        })
                    });
                }
            })
        },

        showByCategory() {
            let category_id = this.selected_category?.id
            
			if (category_id > 0) {
                $('.shw-result').fadeOut(500)
				setTimeout(() => {
					$('.cat-selected-'+category_id).fadeIn()
				}, 500);
			} else {
				$('.shw-result').fadeIn(500)
			}
        },

        routeTo(route) {
            this.$router.push({ name: route })
        },
    }
}


